import { useEffect } from "react";
import { dataLocalManager, TokenManager } from "utils/security/securityUtil";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  dataLocalState,
  userSNSState,
  userTokenState,
} from "recoils/user/userState";
import { dataLocalKeyProviderConst } from "constants/common/providerConst";
import useHeader from "hooks/menu/useHeader";
import useFailedRequests from "./useFailedRequests";
import { v2SetupAxiosInterceptors } from "apis/v2AxiosInstance";

const useGetLocal = () => {
  const [, setUserToken] = useRecoilState(userTokenState);
  const [, setSnsUserInfo] = useRecoilState(userSNSState);
  const dataLocal = useRecoilValue(dataLocalState);
  const { onLogoutBtnClick } = useHeader();
  const { addRequestToQueue, clearQueue, failedRequestsQueue } =
    useFailedRequests();

  const fetchAccessToken = async () => {
    try {
      const data = await TokenManager.getAccessToken();
      if (data) {
        const { token, email, role, nickname } = data;
        setUserToken(token); // Recoil 상태에 저장
        setSnsUserInfo((prev) => ({ ...prev, email: email, role: role, nickname: nickname }));
      }
    } catch (err) {
      onLogoutBtnClick();
    }
  };

  const fetchQueryParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("open") === "login") {
      setSnsUserInfo((prev) => ({ ...prev, isopen: true }));
    }
  };

  const fetchDataInfo = async () => {
    const { sns } = dataLocalKeyProviderConst;
    if (dataLocal) {
      try {
        const data = await dataLocalManager.getInfo({
          snsValue: dataLocal[sns.key],
        });
        if (data) {
          const { sns } = data;
          setSnsUserInfo((prev) => ({ ...prev, sns: sns }));
        }
      } catch (err) {}
    }
  };

  useEffect(() => {
    v2SetupAxiosInterceptors(
      addRequestToQueue,
      clearQueue,
      () => failedRequestsQueue
    );
  }, [addRequestToQueue, clearQueue, failedRequestsQueue]);

  /** @desc 탭이 활성화되거나 최초 마운트 시 데이터를 가져오는 훅 */
  return useEffect(() => {
    const fetchData = () => {
      fetchAccessToken(); // 비동기 함수 호출
      fetchDataInfo();
      fetchQueryParams();
    };

    // ✅ 1. 마운트 시 요청
    fetchData();

    // ✅ 2. 탭 다시 활성화될 때 요청
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        fetchData();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useGetLocal;
